import { gql } from '@apollo/client'

export const GET_INFO_MESSAGE = gql`
  query {
    getInfoMessage {
      active
      id
      message
    }
  }
`
